import React      from 'react'
import Style from './style.sass'

/**
 *  記事エディター
 *  @version 2018/06/10
 */
export default class Counter extends React.Component {

  constructor(props) {

    super(props);

    this.state = {
      text: '',
      count: 0,
      count_no_space: 0,
      count_line: 0,
      count_period: 0,
      count_paper: 0,
    }
  }

  _onChangeText = e => {

    const text = e.target.value.replace(/\r|\n/g, '');
    const count = text.length;
    const count_no_space = text.replace(/ |　/g, '').length;
    const count_line = e.target.value.split(/\r|\n/g).length;
    const count_period = text.split(/。/g).length - 1;
    const count_paper = Math.ceil(count_no_space / 400);

    this.setState({
      text: e.target.value,
      count: count,
      count_no_space: count_no_space,
      count_line: count_line,
      count_period: count_period,
      count_paper: count_paper,
    })
  }

  /**
   *  表示処理
   *  @version 2018/06/10
   */
  render() {

    return (
      <div className={Style.Counter}>
        <h1>文字数カウント</h1>
        <div className='c-info u-mt-15 u-fs-s'>下のテキストエリアに文章を貼り付けることで文字数をカウントすることができます。文章の文字数を知りたい場合にご利用ください。文章を消す際はリセットボタンをご利用ください。</div>
        <textarea className={`${Style.Counter__text} c-form-textarea`} rows={10} value={this.state.text} onChange={this._onChangeText} placeholder='文字数をカウントする文章を入力してください。'></textarea>

        <div className='c-table u-mt-15' style={{maxWidth: '400px'}}>
          <table>
            <tbody>
              <tr>
                <td width='200px'>文字数(スペース含む)</td>
                <td className='u-ta-right'><span className='u-fs-l u-fw-bold'>{this.state.count}</span></td>
              </tr>
              <tr>
                <td>文字数(スペース以外)</td>
                <td className='u-ta-right'><span className='u-fs-l u-fw-bold'>{this.state.count_no_space}</span></td>
              </tr>
              <tr>
                <td>行数</td>
                <td className='u-ta-right'><span className='u-fs-l u-fw-bold'>{this.state.count_line}</span></td>
              </tr>
              <tr>
                <td>句点(。)の数</td>
                <td className='u-ta-right'><span className='u-fs-l u-fw-bold'>{this.state.count_period}</span></td>
              </tr>
              <tr>
                <td>原稿用紙枚数</td>
                <td className='u-ta-right'><span className='u-fs-l u-fw-bold'>{this.state.count_paper}</span></td>
              </tr>
            </tbody>
          </table>
        </div>


        <div className='u-mt-15 u-ta-right'>
          <div className='c-btn-main' onClick={() => this.setState({text: '', count: 0, count_no_space: 0, count_line: 0, count_period: 0, count_paper: 0})}>リセット</div>
        </div>
      </div>
    );
  }
}

